import { render } from "./ConfigFieldRenderer.vue?vue&type=template&id=177a1084&scoped=true"
import script from "./ConfigFieldRenderer.vue?vue&type=script&lang=ts"
export * from "./ConfigFieldRenderer.vue?vue&type=script&lang=ts"

import "./ConfigFieldRenderer.vue?vue&type=style&index=0&id=177a1084&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-177a1084"

export default script